<div class="modal" [ngStyle]="{display: cookiePolicyModal ? 'flex' : null}">
  <div class="modal-body">
    <div class="container">
      <div class="left">
        <h5 class="title">Your privacy is important to us</h5>
        <p class="description">This website uses own cookies and third party cookies, to improve your user's experience,
          collect statistics to optimize site functionality, and deliver content tailored to your interests.
          <span (click)="goToPrivacyPolicy()">Learn more</span>
        </p>
      </div>
      <div class="right d-flex align-items-center">
        <button class="btn btn-outline-primary mr-2" (click)="rejectCookie()">
          Reject <span class="icon end"></span>
        </button>
        <button class="btn btn-primary" (click)="acceptCookie()">
          Accept <span class="icon end"></span>
        </button>
      </div>
    </div>
  </div>
</div>